export default __webpack_public_path__ + "static/media/popup_veg.3f6ba2e6.png";